import { Action, createReducer, on } from '@ngrx/store';

import * as PathwayCardsActions from './pathway-cards.actions';
import * as PathwayCardsState from './pathway-cards.state';

const pathwayCardsReducer = createReducer(
  PathwayCardsState.initialPathwayCardsState,

  on(PathwayCardsActions.loadPathwayCards, (state) => ({
    ...state,
    loading: true
  })),

  on(PathwayCardsActions.loadPathwayCardsSuccess, (state, { pathwayCards }) => {
    return PathwayCardsState.pathwayCardsStateAdapter.setAll(pathwayCards, {
      ...state,
      loading: false
    });
  }),

  on(PathwayCardsActions.loadPathwayCardsError, (state) => ({
    ...state,
    loading: false
  }))
);

export function reducer(
  state: PathwayCardsState.PathwayCardsState | undefined,
  action: Action
) {
  return pathwayCardsReducer(state, action);
}
